import { render, staticRenderFns } from "./sommernachtstraum.vue?vue&type=template&id=62e84c45&scoped=true&"
import script from "./sommernachtstraum.vue?vue&type=script&lang=js&"
export * from "./sommernachtstraum.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62e84c45",
  null
  
)

export default component.exports